var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7768 47.5667L39.8089 51.7258C40.0002 51.7774 40.1754 51.8767 40.318 52.0144C40.4606 52.1521 40.566 52.3237 40.6243 52.5132L45.3404 68.3904C45.4137 68.6311 45.5634 68.8413 45.7669 68.9893C45.9704 69.1373 46.2166 69.215 46.4681 69.2106C46.7197 69.2062 46.963 69.12 47.1612 68.965C47.3594 68.81 47.5017 68.5946 47.5666 68.3515L51.7257 52.3195C51.7773 52.1281 51.8767 51.9529 52.0144 51.8103C52.1521 51.6677 52.3237 51.5623 52.5132 51.504L68.3903 46.7879C68.631 46.7146 68.8413 46.5649 68.9893 46.3614C69.1373 46.1579 69.2149 45.9117 69.2106 45.6602C69.2062 45.4086 69.1199 45.1653 68.9649 44.9671C68.8099 44.7689 68.5946 44.6266 68.3514 44.5617L52.3194 40.4026C52.128 40.351 51.9528 40.2516 51.8102 40.1139C51.6676 39.9762 51.5622 39.8046 51.504 39.6151L46.7879 23.738C46.7145 23.4973 46.5648 23.287 46.3613 23.139C46.1578 22.991 45.9117 22.9134 45.6601 22.9178C45.4085 22.9221 45.1652 23.0084 44.967 23.1634C44.7688 23.3184 44.6265 23.5337 44.5616 23.7769L40.4025 39.8089C40.3509 40.0003 40.2516 40.1755 40.1139 40.3181C39.9762 40.4607 39.8046 40.5661 39.6151 40.6243L23.7379 45.3404C23.4972 45.4138 23.287 45.5635 23.139 45.767C22.991 45.9705 22.9133 46.2166 22.9177 46.4682C22.9221 46.7198 23.0083 46.9631 23.1633 47.1613C23.3183 47.3595 23.5337 47.5018 23.7768 47.5667Z",
    fill: "url(#paint0_linear_1502_2432)",
    stroke: "#FCD34D",
    strokeWidth: 0.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1502_2432",
    x1: 35.6516,
    y1: 28.7425,
    x2: 56.4766,
    y2: 63.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCD34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusStar);
export default __webpack_public_path__ + "static/media/plusStar.5fd9e55af0d58d0e8e3e256c08d21969.svg";
export { ForwardRef as ReactComponent };